webpackJsonp([159635755708896],{

/***/ 1316:
/***/ (function(module, exports) {

	module.exports = {"pathContext":{"name":"StockTransferRequestStatus","kind":"ENUM","type":"OBJECT","fields":null,"description":null,"enumValues":[{"deprecationReason":null,"description":null,"isDeprecated":false,"name":"COMPLETED"},{"deprecationReason":null,"description":null,"isDeprecated":false,"name":"DRAFT"},{"deprecationReason":null,"description":null,"isDeprecated":false,"name":"REQUESTED"}],"possibleTypes":null}}

/***/ })

});


// WEBPACK FOOTER //
// path---enum-stock-transfer-request-status-50ee055dd4e6234e08d2.js